<template>
  <div class="CategoryProducts">
    <div>
      <ComposableTable class="border rounded"
        :data="products"
        :loading="loading"
        :columns="columns"
        :variables="variables"
        :page-size="20"
      >
        <template #before-first-row>
          <TableRowAction
            message="Voeg nieuw product toe aan deze categorie."
            :showAlways="true"
            @close="productSelected = []"
            @open="openCheckboxOptions"
          >
            <div class="p-2">
              <CheckboxOptions
                :selected.sync="productSelected"
                :resetWhenClose="true"

                endpoint="/api/products"
                uid="sku"
                searchQuery="search"
                :params="params"

                ref="table-row-action"
              >
                Select products

                <template v-if="productSelected.length" #end-of-list>
                  <div class="d-flex">
                    <button class="mx-2 btn btn-primary flex-grow-1" @click="saveSelected">
                      Opslaan
                    </button>
                  </div>
                </template>
              </CheckboxOptions>
            </div>
          </TableRowAction>
        </template>

        <template #cell-active="{value}">
          <span class="product-status" :class="value + ''">
            {{ value == true ? "Online" : "Offline" }}
          </span>
        </template>

        <template #row-action="{item}">
          <div class="delete-icon" @click="removeProductFromCategory(item)">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </div>
        </template>
      </ComposableTable>

      <div class="d-flex justify-content-center my-2">
        <Pagination
          :max="max"

          :value="page"
          @input="p => page = p"
        />
      </div>

      <div
        v-if="!loading && products.length === 0"
        class="d-flex justify-content-center align-items-center position-absolute"
        style="height: 400px; bottom: 0; left: 50%; transform: translateX(-50%)"
      >
        <EmptyStatePlaceholder key="empty-staet"
          title="Dit product heeft geen mutatiegebeurtenissen."
        >
          <svg class="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5 3a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2V5a2 2 0 00-2-2H5zm0 2h10v7h-2l-1 2H8l-1-2H5V5z" clip-rule="evenodd"></path></svg>
        </EmptyStatePlaceholder>
      </div>
    </div>

  </div>
</template>

<script>

import EmptyStatePlaceholder from "../../layout/EmptyStatePlaceholder.vue"
import InfiniteScrolling from "../../layout/InfiniteScrolling.vue"
import ProductListItem from "../Product/ProductListItem.vue"
import SimpleTable from "../Product/SimpleTable/SimpleTable.vue"
import Pagination from "../../layout/Pagination.vue"
import CheckboxOptions from "../../layout/Table/DropdownCheckboxTableFilters/CheckboxOptions.vue"
import ComposableTable from "../Product/ComposableTable/ComposableTable.vue"

import TableRowAction from "../../layout/TableComposables/TableRowAction.vue"

const page_size = 20

export default {
  components: {
    ProductListItem,
    SimpleTable,
    EmptyStatePlaceholder,
    Pagination,
    InfiniteScrolling,
    TableRowAction,
    CheckboxOptions,
    ComposableTable,
  },
  props: {
    categoryUid: String,
  },
  async created() {
    this.fetch()
  },
  data() {
    return {
      total: 0,
      page: 1,

      productSelected: [],
      products: [],
      loading: false,
    }
  },
  methods: {
    openCheckboxOptions() {
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.$refs["table-row-action"].open()
        })
      })
    },
    async fetch() {
      this.loading = true
      const {results, total} = (await this.axios.get(`/api/products`, {
        params: {
          page: this.page,
          categories: [this.categoryUid],

          page_size,
        }
      })).data
      this.products = results
      this.total = total

      this.loading = false
    },

    removeProductFromCategory({sku}) {
      this.$handlePromise(async () => {
        let {categories} = (await this.axios.get(`/api/products/${sku}`)).data
        categories = categories.map(cat => cat.uid)

        const index = categories.indexOf(this.categoryUid)
        if (index > -1) {
          categories.splice(index, 1)
          await this.axios.put(`/api/products/${sku}`, { categories })
        }

        this.page = 1
        this.fetch()
      })
    },
    saveSelected() {
      this.$handlePromise(async () => {
        await Promise.all(
          this.productSelected.map(async ({ sku }) => {
             let {categories} = (await this.axios.get(`/api/products/${sku}`)).data
             categories = categories.map(cat => cat.uid)

             if (!categories.includes(this.categoryUid)) {
                await this.axios.put(`/api/products/${sku}`, {
                  categories: [...categories, this.categoryUid],
                })
             }
          })
        )
        this.$refs["table-row-action"].close()

        this.page = 1
        this.fetch()
      })
    },
  },
  computed: {
    params() {
      return {
        not_in_categories: [this.categoryUid],
      }
    },
    max() {
      return Math.ceil(this.total / page_size)
    },

    columns() {
      return ["Naam", "Verkoopprijs", "Productvoorraad", "SKU", "Actief", "Ean13"]
    },
    variables() {
      return ["name", "recommended_retail_price", "product_stock", "sku", "active", "ean13"]
    },
    computedProducts() {
      return this.products.length ? this.products : this.placeholder
    },
  },
  watch: {
    page() {
      this.fetch()
    },
  },
}

</script>

<style>

.CategoryProducts, .CategoryProducts table, .CategoryProducts tbody, .CategoryProducts thead {
  display: block;
  max-width: 928px !important;
}

.CategoryProducts .product-status {
  font-weight: 600 !important;
}

.CategoryProducts .product-status.true {
  color: var(--apple-green);
}

.CategoryProducts .product-status.false {
  color: var(--red);
}


</style>

<style scoped>


</style>
